import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerLoginFormResourceBundleEn(i18next: i18n): void {
  i18next.addResourceBundle('en', 'record-it-components', {
    form: {
      LoginForm: {
        createAccount: 'Create account',
        emailLabel: 'Email',
        forgotPassword: 'Forgot password',
        loginButtonLabel: 'Login',
        passwordLabel: 'Password',
        title: 'Login'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>);
}